import { Box, Container, Link } from "@mui/material";
import Paper from "../../modules/components/Paper";
import React from "react";
import Typography from "../../modules/components/Typography";
import Button from "../../modules/components/Button";
import {useNavigate, useOutletContext} from "react-router-dom";
import Reasons from "./Reasons";

const weeklyTextCountLimit = 50;

const ThankYou = ({ url, userInfo, handleClick }) => (
  <React.Fragment>
    <Typography variant="h3" gutterBottom marked="center" align="center" pb={4}>
      You're a Collector
    </Typography>
    <Typography variant="body2" align="center">
      Thank you for supporting the site! Don't forget to <Link style={{cursor: 'pointer'}} onClick={() => handleClick("/update-profile")} >Update your Contact Info</Link> before you use phone notifications!
      <br/><br/>
      {`You have received ${userInfo?.weeklyTextCount ?? 0} / ${weeklyTextCountLimit} text notifications this week.`} 
      <br/><br/>
      Collectors have access to:
    </Typography>
    <Reasons weeklyTextCountLimit={weeklyTextCountLimit} />
    <Box sx={{ m: 2 }}>
      <Button 
        variant="contained"
        fullWidth
        href={url}
      >
        Manage Your Subscription
      </Button>
    </Box>
  </React.Fragment>
);

const BecomeACollector = ({ url }) => (
  <React.Fragment>
    <Typography variant="h3" gutterBottom marked="center" align="center" pb={4}>
      Become a Collector
    </Typography>
    <Typography variant="body2" align="center">
      For $4 per month, you will gain access to:
    </Typography>
    <Reasons weeklyTextCountLimit={weeklyTextCountLimit} />
    <Box sx={{ m: 2 }}>
      <Button 
        variant="contained"
        fullWidth
        href={url}
      >
        Upgrade Now
      </Button>
    </Box>
  </React.Fragment>
);

export default function Upgrade() {

  const navigate = useNavigate();

  const handleClick = (path) => {
    navigate("/dashboard" + path);
  }

  const [userInfo,,] = useOutletContext();

  const PROD_UPGRADE_URL = `https://buy.stripe.com/5kA17n5teby5eM87su?prefilled_email=${userInfo?.email}&client_reference_id=${userInfo?.id}`;
  const TEST_UPGRADE_URL = `https://buy.stripe.com/test_4gwbL31Z74r5bLy3cf?prefilled_email=${userInfo?.email}&client_reference_id=${userInfo?.id}`;
  const upgradeUrl = window.location.href.includes("watchexchanger") ? PROD_UPGRADE_URL : TEST_UPGRADE_URL;

  const PROD_MANAGE_URL = `https://billing.stripe.com/p/login/dR68Af7HS4Z456odQQ?prefilled_email=${userInfo?.email}`;
  const TEST_MANAGE_URL = `https://billing.stripe.com/p/login/test_7sIg0G3Sfga523e000?prefilled_email=${userInfo?.email}`;
  const manageUrl = window.location.href.includes("watchexchanger") ? PROD_MANAGE_URL : TEST_MANAGE_URL;

  return (
    <Container maxWidth="sm" sx={{ flexGrow: 1, p: 2 }}>
      <Box sx={{ mt: 2, mb: 4 }}>
        <Paper
          background="light"
          sx={{ py: { xs: 4, md: 8 }, px: { xs: 3, md: 6 } }}
        >
          {userInfo?.collector ? 
            <ThankYou url={manageUrl} userInfo={userInfo} handleClick={handleClick} />
            :
            <BecomeACollector url={upgradeUrl} />
          }
        </Paper>
      </Box>
    </Container>
  );
}